import {Component, Input, OnInit} from '@angular/core';
import {BuildMoneyProject} from '../../../../../class/lifeproject/build-money-project';

@Component({
  selector: 'app-build-money-view',
  templateUrl: './build-money-view.component.html',
  styleUrls: ['./build-money-view.component.css']
})
export class BuildMoneyViewComponent implements OnInit {

  @Input()
  buildMoneyProject: BuildMoneyProject;

  constructor() {
  }

  ngOnInit() {
  }

}
